import {Sprite_ItemExtraInfo} from "../sprites/ItemExtraInfo.sprite";
import {Sprite_MapInvHelp} from "../sprites/InventoryHelp.sprite";

export class InventoryController {
  constructor(inventorySprite, layer) {
    this.invSprite = inventorySprite;
    this.layer = layer;

    this.params = YsServices.equipmentService.getSizeCellsParameter();
    this.MAX = this.params.columnsPerPage * this.params.rowsPerPage;

    this._wallMargin = YsServices.equipmentService.getUIMapInventorySettings().screenOutSafeMargin;
    this.__pressTimer = 0;
    this.invSprite.visible = false;
    this.refreshTitle = new KDCore.TimedUpdate(3, this._onTitleTick.bind(this));
    this.goldRefreshThread = new KDCore.TimedUpdate(10, this._onGoldTick.bind(this));
    this._categoryLastPage = {};

    this._config();
  }

  isInventoryActive() {
    return this.invSprite.visible;
  }

  open() {
    if (this.isInventoryActive()) {
      return;
    }
    this.invSprite.createMain();
    this.content = this.invSprite._content;

    this._onGoldTick();

    this.invSprite.visible = true;
    this.invSprite.playStartSE();
  }

  close() {
    if (!this.isInventoryActive()) return;

    this._hideHelp();
    this.invSprite.visible = false;
    this.content = null;
    this.invSprite.destroyMain();
  }

  showNextPage() {
    if (!this.isInventoryActive()) return;
    if (this.isSomeItemFocused()) return;

    if (this._currentPage === (this._maxPages - 1)) {
      return;
    }

    return this._loadPage(this._currentPage + 1);
  }

  showPrevPage() {
    if (!this.isInventoryActive()) return;
    if (this.isSomeItemFocused()) return;

    if (this._currentPage === 0) {
      return;
    }

    return this._loadPage(this._currentPage - 1);
  }

  terminate() {
    $gameTemp._tempItemForParty = null;
    if (this.isInventoryActive()) {
      this.close();
    }
  }

  isSomeItemFocused() {
    return this.content.isFocused();
  };

  clickAtFocusItem(index) {
    this.clearFocus();
  };

  loadItemsInCategory(categoryIndex = 0) {
    if (!this.isInventoryActive()) return;
    if (this.isSomeItemFocused()) return;

    this._hideHelp();
    this._onNewCategoryWillLoad();

    this._loadedCatIndex = categoryIndex;

    this.content.clearAllItems();
    this.content.prepareForCategory(categoryIndex);

    switch (categoryIndex) {
      case 0:
        this.showItems();
        break;
      case 1:
        this.showWeapons();
        break;
      case 2:
        this.showArmors();
        break;
      case 3:
        this.showKeys();
    }

    this._onNewCategoryLoaded();
  }

  showItems() {
    this._loadedItems = $gameParty.getAllItemsByInvCategory(0);
    this._sortByUsable();
    this._setPages();
    this._showItemsGroup(0);
  }

  showKeys() {
    this._loadedItems = $gameParty.getAllItemsByInvCategory(3);
    this._setPages();
    this._showItemsGroup(0);
  }

  showWeapons() {
    $gameTemp._equipmentWeapCandidates = {};
    const items = $gameParty.weapons();

    let equiped = [];
    if (YsServices.equipmentService.get_ShowEquipedItemsInInventory()) {
      equiped = $gameParty.getAllEquippedItems(DataManager.isWeapon);
    }

    items.sort(function(a, b) {
      if ($gameParty.canAnyEquip(a)) {
        return -1;
      } else {
        return 1;
      }
    });

    this._loadedItems = equiped.concat(items);
    this._sortByEquiped(DataManager.isWeapon);
    this._setPages();
    this._showItemsGroup(0);
  }

  showArmors() {
    $gameTemp._equipmentArmrCandidates = {};
    const items = $gameParty.armors();

    let equiped = [];
    if (YsServices.equipmentService.get_ShowEquipedItemsInInventory()) {
      equiped = $gameParty.getAllEquippedItems(DataManager.isArmor);
    }

    items.sort(function(a, b) {
      if ($gameParty.canAnyEquip(a)) {
        return -1;
      } else {
        return 1;
      }
    });

    this._loadedItems = equiped.concat(items);
    this._sortByEquiped(DataManager.isArmor);
    this._setPages();
    this._showItemsGroup(0);
  }

  update() {
    if (this.isInventoryActive()) {
      this.updateWhenOpen();
    } else {
      this._hideHelp();
    }
  }

  updateWhenOpen() {
    this.refreshTitle.update();

    if (this.goldRefreshThread) {
      this.goldRefreshThread.update();
    }

    this._updateHelp();

    if (this.isSomeItemFocused()) {
      this.updateClearFocusClick();
    }
  }

  equipInventoryItem(cell) {
    this._equipInventoryItemOnActor($gameParty.leader(), cell.item);
  };

  clickAt(index) {
    const cell = this.content.getCellAt(index);

    if (!cell) return;
    if (!cell.item) return;

    this._onAction(cell);
  }

  useInventoryItem(actor, item) {
    if (!item) return;

    const actorIndex = $gameParty.allMembers().indexOf(actor);
    if (actorIndex < 0) return;

    SoundManager.playUseItem();
    actor.useItem(item);

    this.item = function() {
      return item;
    };

    this.user = function() {
      return actor;
    };

    this._actorWindow = {};
    this._actorWindow.index = function() {
      return actorIndex;
    };

    this.itemTargetActors = function() {
      return Scene_Item.prototype.itemTargetActors.call(this);
    };

    Scene_Item.prototype.applyItem.call(this);

    delete this._actorWindow;
    delete this.item;
    delete this.user;
    delete this.itemTargetActors;
  }

  updateClearFocusClick() {
    if (TouchInput.isTriggered()) {
      if (this.content.isMouseInFocusZone()) {
        this.clearFocus();
      }
    }
  };

  clearFocus() {
    if (this.sliderController) {
      this.sliderController.close();
    }

    this.sliderController = null;
    this.content.clearFocus();
    this.loadItemsInCategory(this._loadedCatIndex);
    return $gameTemp._pkdMICellFocused = false;
  };

  placeWeaponToFavorite(index) {
    if (this._loadedCatIndex === 2) return false;

    const cellUnderMouse = this.content.getHoveredCell();
    if (!cellUnderMouse) return false;
    if (!cellUnderMouse.isEnabled()) return false;

    if (cellUnderMouse.item) {
      $gameParty.leader().setFavWeap(cellUnderMouse.item, index);
      SoundManager.playEquip();
      this._refreshCellItem(cellUnderMouse);
      return true;
    }

    return false;
  }

  isSomeCellUnderMouse() {
    return this.content.getHoveredCell() != null;
  }

  placeItemToPanel(index) {
    if (this._loadedCatIndex === 1) return false;

    const cellUnderMouse = this.content.getHoveredCell();
    if (!cellUnderMouse) return false;
    if (!cellUnderMouse.isEnabled()) return false;
    if(!cellUnderMouse.item) return false;

    $gameParty.leader().setItemOnPanel(cellUnderMouse.item.id, index - 1);
    SoundManager.playEquip();
    this._refreshCellItem(cellUnderMouse);
    return true;
  }

  _onAction(cell) {
    this._onActionItem(cell);
  }

  _setItemToCell(cell, item) {
    return cell.setItem(item);
  }

  _onActionItem(cell) {
    if (!cell.isEnabled()) return;
    if (this.isSomeItemFocused()) return;

    switch (this._loadedCatIndex) {
      case 0:
      case 3: // * ITEMS
        this._onActionOnGameItem(cell);
        break;
      case 1:
      case 2: // * EQUIPMENT
        this._onActionOnEquipItem(cell);
    }
  }

  _onActionOnEquipItem(cell) {
    if (!cell._inSpecialState) {
      this.equipInventoryItem(cell);
    } else {
      if (cell.isCanBeUnEquiped()) {
        this._unEquipItem(cell);
      } else {
        SoundManager.playBuzzer();
        return;
      }
    }

    this.loadItemsInCategory(this._loadedCatIndex);
  };

  _unEquipItem(cell) {
    const etype = cell.item.etypeId;
    const actor = cell._getEquipmentActor();

    this._equipFromInv(actor, etype, null);
  };

  _equipInventoryItemOnActor(actor, item) {
    const etype = item.etypeId;

    if (actor.isEquipTypeLocked(etype)) {
      SoundManager.playBuzzer();
    } else {
      this._equipFromInv(actor, etype, item);
      this.loadItemsInCategory(this._loadedCatIndex);
    }
  };

  _sortByUsable() {
    if (!YsServices.equipmentService.get_MapInventorySortItems()) return;

    const sortMethod = function(a, b) {
      if (a.occasion === 2 || a.occasion === 0) {
        return -1;
      } else {
        return 1;
      }
    };

    const sortMethod2 = function(a, b) {
      if (a.id < b.id) {
        return -1;
      } else {
        return 1;
      }
    };

    this._loadedItems.sort(sortMethod2);
    this._loadedItems.sort(sortMethod);
  }

  _onActionOnGameItem(cell) {
    if(!cell._inSpecialState) {
      this.useInventoryItem($gameParty.leader(), cell.item);
    }
  };

  _equipFromInv(actor, etypeId, item) {
    const slotId = actor.equipSlots().indexOf(etypeId);

    if (slotId >= 0) {
      if (actor.isEquipChangeOk(slotId)) {
        if (!item) {
          // * Отключаем Notify для ABS Z
          $gameTemp.aaNotNeedItemPopUpNotify = true;
        }
        actor.changeEquip(slotId, item);
        SoundManager.playEquip();
        // * Включаем (если отключали)
        if ($gameTemp.aaNotNeedItemPopUpNotify) {
          $gameTemp.aaNotNeedItemPopUpNotify = null;
        }
      } else {
        SoundManager.playBuzzer();
      }
    }
  }

  _refreshCategoryButtons() {
    this.invSprite._header.enableAllButtons();
    if(this.invSprite._header.categoryBtns[this._loadedCatIndex]) {
      this.invSprite._header.categoryBtns[this._loadedCatIndex].disable();
    }
  }

  _onNewCategoryLoaded() {
    this._refreshCategoryButtons();

    const pageIndex = this._categoryLastPage[this._loadedCatIndex];
    if (pageIndex > 0 && pageIndex < this._maxPages) {
      return this._loadPage(pageIndex);
    }
  }

  _sortByEquiped(itemTypeMethod) {
    if (!YsServices.equipmentService.get_MapInventorySortEquips()) return;

    const equiped = $gameParty.getAllEquippedItems(itemTypeMethod);

    this._loadedItems.sort(function(a, b) {
      if (equiped.contains(a)) {
        return -1;
      } else {
        return 1;
      }
    });
  }

  _showItemsGroup(pageIndex = 0) {
    var i, j, ref, ref1;
    let cellIndex = 0;

    const s = pageIndex * this.MAX;
    const e = s + this.MAX;

    for (i = j = ref = s, ref1 = e; (ref <= ref1 ? j < ref1 : j > ref1); i = ref <= ref1 ? ++j : --j) {
      const item = this._loadedItems[i];
      const cell = this.content.getCellAt(cellIndex++);
      this._setItemToCell(cell, item);
    }
  }

  _refreshPageInfo() {
    const footerSprite = this.invSprite._footer;
    footerSprite.disableArrows();
    footerSprite.drawPagesCount(this._currentPage + 1, this._maxPages);

    if (this._maxPages > 1) {
      footerSprite._arrowR.enable();
      footerSprite._arrowL.enable();
      if (this._currentPage === 0) {
        footerSprite._arrowL.disable();
      }
      if (this._currentPage === (this._maxPages - 1)) {
        return footerSprite._arrowR.disable();
      }
    }
  }

  _setPages() {
    this._currentPage = 0;
    this._maxPages = 1;

    if (this._loadedItems.length <= this.MAX) {
      this._maxPages = 1;
    } else {
      this._maxPages = Math.ceil(this._loadedItems.length / this.MAX);
    }

    this._refreshPageInfo();
  }

  _onNewCategoryWillLoad() {
    if (!this._loadedCatIndex ) return;
    if (this._maxPages === 1) return;

    this._categoryLastPage[this._loadedCatIndex] = this._currentPage;
  }

  _loadPage(pageIndex) {
    if (pageIndex <= 0) {
      this._currentPage = 0;
      this.loadItemsInCategory(this._loadedCatIndex);
    } else {
      if (!this._loadedItems) return;

      this.content.clearAllItems();
      this._hideHelp();
      this._currentPage = pageIndex;
      this._showItemsGroup(pageIndex);
      this._refreshPageInfo();
    }
  }

  _onTitleTick() {
    let cellUnderMouse = this.content.getHoveredCell();

    if (cellUnderMouse && cellUnderMouse.item) {
      return this.content.drawItemName(cellUnderMouse.item.name);
    } else if (cellUnderMouse) {
      return this.content.drawItemName("");
    } else {
      cellUnderMouse = this.invSprite._header.getHoveredIndex();
      if (cellUnderMouse) {
        return this.content.drawItemName(this._getCategoryTitle(cellUnderMouse));
      } else {
        return this.content.drawItemName(this._getCategoryTitle(this._loadedCatIndex));
      }
    }
  }

  _getCategoryTitle(index) {
    switch (index) {
      case 0:
        return TextManager.item;
      case 1:
        return TextManager.weapon;
      case 2:
        return TextManager.armor;
      case 3:
        return TextManager.keyItem;
    }
    return "";
  }

  _onGoldTick() {
    this.invSprite._footer.drawGold($gameParty.gold());
  }

  _config() {
    this._moveToLastPos();
  }

  _moveToLastPos() {
    if ($gameTemp.__lastInventoryDragPos) {
      return this.invSprite.move($gameTemp.__lastInventoryDragPos);
    }
  }

  _isProperMouseCursorPos(pos) {
    if (this._wallMargin === 0) return true;

    const maxW = Graphics.width;
    const maxH = Graphics.height;
    const wall = this._wallMargin;

    if (pos.x < wall) {
      return false;
    }

    if (pos.x > (maxW - wall)) {
      return false;
    }

    if (pos.y < wall) {
      return false;
    }

    if (pos.y > (maxH - wall)) {
      return false;
    }

    return true;
  }

  _saveLastDragPos() {
    return $gameTemp.__lastInventoryDragPos = [this.invSprite.x, this.invSprite.y];
  }

  _refreshCellItem() {
    this._loadPage(this._currentPage);
  }

  _updateHelp() {
    if (this._itemDescShowTimer) {
      this._itemDescShowTimer.update();
    }

    const hovered = this.content.getHoveredCell();
    const haveExtraInfo = this._isCellHaveExtraInfo(hovered);

    if (hovered && hovered.item && !haveExtraInfo) {
      this._hideExtraInfo();
      this._showHelp(hovered);
    } else {
      this._hideHelp();
      if (haveExtraInfo) {
        this._showExtraInfo(hovered);
      } else {
        this._hideExtraInfo();
      }
    }

    if (this._itemDescWindow) {
      this._updateEquipStatShow();
    }
  };

  _isCellHaveExtraInfo(cell) {
    // if (!TouchInput.kdIsPressed2()) return false
    if (!cell) return false;
    if (!cell.item) return false;

    return YsServices.equipmentService.IsHaveExtraInfo(cell.item);
  };

  _hideExtraInfo() {
    if (!this.__lastExtraInfoCell) return;

    this._destroyExtraHelpWindow();
    this.__lastExtraInfoCell = null;
  };

  _showExtraInfo(cell) {
    if(this.__lastExtraInfoCell === cell) return;

    this._hideExtraInfo();
    this.__lastExtraInfoCell = cell;
    const info = YsServices.equipmentService.GetExtraInfo(cell.item);

    if (info) {
      this._createExtraHelpWindow(info);
    }
  };

  _createExtraHelpWindow(info) {
    this._itemExtraHelpWindow = new Sprite_ItemExtraInfo(info);
    this.layer.addChild(this._itemExtraHelpWindow);
  };

  _destroyExtraHelpWindow() {
    if (!this._itemExtraHelpWindow) return;

    this.layer.removeChild(this._itemExtraHelpWindow);
    this._itemExtraHelpWindow.visible = false;
    this._itemExtraHelpWindow = null;
  };

  _updateEquipStatShow() {
    if (TouchInput.wheelY >= 20) {
      this._itemDescWindow.showItemStats();
    } else if (TouchInput.wheelY <= -20) {
      this._itemDescWindow.showItemStats(true);
    }
  };

  _showHelp(cell) {
    if (this.__lastHelpItem === cell) {

    } else {
      this._hideHelp();
      this.__lastHelpItem = cell;
      this._createHelpWindow();
    }
  };

  _createHelpWindow() {
    this._itemDescWindow = new Sprite_MapInvHelp();
    this._waitTime = this._itemDescWindow.delay();
    this._itemDescShowTimer = new KDCore.TimedUpdate(1, this._onShowTimeTick.bind(this));
    this._itemDescWindow.opacity = 0;
    this._itemDescWindow.setup(this.__lastHelpItem);

    this._placeDescription();
    this.layer.addChild(this._itemDescWindow);
  };

  _onShowTimeTick() {
    if (this._waitTime > 0) {
      return this._waitTime--;
    } else {
      if (this._itemDescWindow.opacity < 255) {
        return this._itemDescWindow.opacity += 20;
      } else {
        return this._itemDescShowTimer = null;
      }
    }
  };

  _placeDescription() {
    if (!this._itemDescWindow) return;
    this._itemDescWindow.refreshPlacement();
  };

  _hideHelp() {
    if (!this.__lastHelpItem) return;

    this._itemDescShowTimer = null;
    this._destroyHelpWindow();
    this.__lastHelpItem = null;
  };

  _destroyHelpWindow() {
    this._itemDescShowTimer = null;
    if (!this._itemDescWindow) return;

    this.layer.removeChild(this._itemDescWindow);
    this._itemDescWindow.visible = false;
    this._itemDescWindow = null;
  };
}
